import React from 'react';
import { Editor as TinyMCEEditor } from 'tinymce';

import WysiwygEditor from '../../common/WysiwygEditor';

type EditorProps = {
  initialValue: string;
  editorRef: React.MutableRefObject<TinyMCEEditor | null>;
};

const Editor = ({ initialValue, editorRef }: EditorProps) => {
  return (
    <WysiwygEditor
      mainEditorConfig={{
        initialValue,
      }}
      editorInitConfig={{
        height: '100%',
        menubar: false,
        statusbar: false,
        plugins: 'advlist lists link image table help',
        toolbar: `undo redo | fontfamily fontsize bold italic underline forecolor backcolor | align lineheight bullist numlist indent outdent | removeformat | table | link | help`,
        content_style: 'body { font-size: 16px; }',
        default_font_stack: ['Arial'],
        font_size_formats: '8pt 9pt 10pt 11pt 12pt 14pt 18pt 24pt 30pt 36pt 48pt 60pt 72pt 96pt',
        toolbar_mode: 'sliding',
      }}
      editorRef={editorRef}
    />
  );
};

export default Editor;
